// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckBox_root__3e0XA","input":"CheckBox_input__234bs","ellipse":"CheckBox_ellipse__3Lay6","text":"CheckBox_text__1Wxev","customInputs":"CheckBox_customInputs__38gIv"};